import Flickity from 'flickity';

const VideoPlaylist = {
	Init() {
		const carousel = document.querySelector('.carousel-flickity');
		if (carousel) {
			const flkty = new Flickity(carousel);

			flkty.on('change', event => {
				if (carousel.querySelector('.is-playing')) {
					carousel.querySelector('.is-playing video').pause();
				}
			});
		}
	}
};

export default VideoPlaylist;
